import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import React from 'react'
import PubSub from 'pubsub-js'
import './DialogPayment.css'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import { StyledDialogTitle, StyledDialogTitleNormal } from '../../components/Dialog/StyledDialogTitle'
import { StyledDialogText } from '../../components/Dialog/DialogText'
import { StyledDialogCancelButton } from '../../components/Dialog/DialogButton'

type DialogPaymentState = {
  // [x:string]:any,
  showDialog?: boolean
  message?: string
}

interface DialogPaymentProps {
  onPay: () => void
}

class DialogPaymentError extends React.Component<
  DialogPaymentProps,
  DialogPaymentState
> {
  constructor(props) {
    super(props)
    this.state = {
      showDialog: false,
    }
  }

  componentDidMount(): void {
    PubSub.subscribe('dialog-payment-error-show', (msg: string, data: any) => {
      this.setState({ message: data }, () => this.show())

    });

  }

  /**
   * Shows the dialog
   */
  show(): void {
    this.setState({
      showDialog: true,
    });

    PubSub.publish("command_out", {
      command: "dialog_cardpayment_show",
      data: { status: this.state.message },
    });
  }

  /**
   * Closes the dialog
   */
  closeDialog(): void {
    this.setState({
      showDialog: false,
    });
    PubSub.publish("command_out", {
      command: "dialog_cardpayment_hide",
    });
  }

  /**
   * Publishes event that payment is clicked
   * and closes the dialog
   */
  payNow(): void {
    this.props.onPay()
    this.closeDialog()
  }

  componentWillUnmount(): void { }

  /**
   * Renders the dialog
   * @returns
   */
  render(): ReactJSXElement {
    return (
      <>
        <Dialog
          id="DialogPayment"
          open={this.state.showDialog}
          keepMounted
          onClose={() => this.closeDialog()}
        >
          <StyledDialogTitleNormal>ERROR</StyledDialogTitleNormal>
          <DialogContent sx={{minWidth:300}}>
            <DialogContentText className="DialogContentText">
              <StyledDialogText>
                {this.state.message}
              </StyledDialogText>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="DialogActions">
            <StyledDialogCancelButton
              onClick={() => this.closeDialog()}
            >
              Close
            </StyledDialogCancelButton>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

export default DialogPaymentError
